/// FOURJS_START_COPYRIGHT(D,2016)
/// Property of Four Js*
/// (c) Copyright Four Js 2016, 2026. All Rights Reserved.
/// * Trademark of Four Js Development Tools Europe Ltd
///   in the United States and elsewhere
///
/// This file can be modified by licensees according to the
/// product manual.
/// FOURJS_END_COPYRIGHT

"use strict";

/**
 * @readonly
 * @enum {string};
 */
gbc.constants.baseEvents = {
  /** Triggered when a new application is added to the session */
  applicationAdded: "g_applicationAdded",
  /** Triggered when an application is removed from the session */
  applicationRemoved: "g_applicationRemoved",
  // Triggered when an application is set as current
  applicationSwitched: "g_applicationSwitched",
  childrenNodeCreated: "g_childrenNodeCreated",
  controllerCreated: "g_controllerCreated",
  displayEnd: "g_displayEnd",
  idleChanged: "g_idleChanged",
  nodeCreated: "g_nodeCreated",
  nodeDestroyed: "g_nodeDestroyed",
  ordersManaged: "g_ordersManaged",
  gotRN0: "g_gotRN0"
};

gbc.constants.applicationEvents = {
  // Event triggered when a window is added to an application
  windowAdded: "g_windowAdded",
  // Event triggered when a window is removed from an application
  windowRemoved: "g_windowRemoved",
  // Event triggered when the current window have changed
  currentWindowChanged: "g_currentWindowChanged"
};
